import { trackEventFn } from '@web-platform/global-components-utils/tracking';

import { SMART_METRICS } from '../../common/tracking/constants';
import { smartMetricEvent } from '../../userTrackingEvents';

const trackSmartMetric = (smartMetricName: string) => {
  trackEventFn(smartMetricEvent(smartMetricName));
};

export const trackFlightsTabClickedSmartMetric = () => {
  trackSmartMetric(SMART_METRICS.Header_FLIGHTS_Tab_Clicked);
};

export const trackHotelsTabClickedSmartMetric = () => {
  trackSmartMetric(SMART_METRICS.Header_HOTELS_Tab_Clicked);
};

export const trackCarhireTabClickedSmartMetric = () => {
  trackSmartMetric(SMART_METRICS.Header_CARHIRE_Tab_Clicked);
};

export const trackPackagesTabClickedSmartMetric = () => {
  trackSmartMetric(SMART_METRICS.Header_PACKAGES_Tab_Clicked);
};
